import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vehicleInfoDetails" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "vehicleInfoDetailsSeparator" }, " | ", -1)
const _hoisted_3 = { class: "vehicleInfoDetailsMileage" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "vehicleInfoDetailsSeparator" }, " | ", -1)
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "vehicleInfoName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.vehicle.year), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatVehicleMileage(_ctx.vehicle.miles || 0)) + " " + _toDisplayString(_ctx.$t('Car miles')), 1),
      _hoisted_4,
      _createVNode(_component_v_tooltip, {
        text: _ctx.$t('srp.common.copiedToClipboard'),
        modelValue: _ctx.showStockNumberTooltip,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showStockNumberTooltip) = $event)),
        location: "top",
        class: "top",
        "open-on-hover": false
      }, {
        activator: _withCtx(({ props }) => [
          _createElementVNode("div", _mergeProps({
            class: "vehicleInfoDetailsStockNumber",
            id: `vehicleInfoDetailsStockNumber-${_ctx.vehicle.stockNumber}`,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)), ["prevent","stop"]))
          }, props), _toDisplayString(_ctx.$t('Stock Number')) + " " + _toDisplayString(_ctx.vehicle.stockNumber), 17, _hoisted_5)
        ]),
        _: 1
      }, 8, ["text", "modelValue"])
    ]),
    _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.formatVehicleName(_ctx.vehicle.make, _ctx.vehicle.model, _ctx.vehicle.trim)), 1)
  ]))
}